import {useNavigate} from "react-router-dom";
import React, {Fragment, useEffect, useState} from "react";
import {getVenueSession} from "../../requests/AppSession";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle, Transition} from '@headlessui/react'
import {CheckIcon, XMarkIcon} from '@heroicons/react/24/outline'
import CircularProgress from "@mui/material/CircularProgress";
import {ArrowPathIcon, CheckCircleIcon, UsersIcon} from "@heroicons/react/20/solid";
import {NumericFormat} from "react-number-format";
import dateFormat from "dateformat";
import {useAuth0} from "@auth0/auth0-react";
import {
    findVenueDancersPayout,
    findVenueDancerTipsAndDancesHistory,
    findVenueDancerTipsAndDancesTotal,
    processDancerTips
} from "../requests/AppRequestDancer";
import FormError from "./FormError";
import soundError from "./sound/error.mp3";
import VTPayoutDancerQRReader from "./VTPayoutDancerQRReader";
import {DancerListSkeleton} from "./VTSkeletons";
import sound from "./sound/tip.mp3";

export default function VTDancerPayoutAllBoard() {

    let navigate = useNavigate();

    const {isLoading, getAccessTokenSilently} = useAuth0();

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [availableToPayOutVT, setAvailableToPayOutVT] = React.useState(null);
    const [payoutPinNumber, setPayoutPinNumber] = React.useState(null);

    const [showQRReader, setShowQRReader] = useState(false);

    const [people, setPeople] = React.useState(null);
    const [peopleFiltered, setPeopleFiltered] = React.useState(null);

    const [errorMessage, setErrorMessage] = React.useState(null);
    const [showError, setShowError] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(null);

    const [selectedDancerId, setSelectedDancerId] = React.useState(null);

    const [dancer, setDancer] = React.useState(null);

    const [dancerOnStage, setDancerOnStage] = React.useState(null);

    const [isProcessingDancerTips, setIsProcessingDancerTips] = React.useState(false);

    const [open, setOpen] = useState(false);
    const [openPayoutPinNumber, setOpenPayoutPinNumber] = useState(false);
    const [openPayoutSuccessful, setOpenPayoutSuccessful] = React.useState(false);

    const [totalPayout, setTotalPayout] = React.useState(0);

    const [selectedDancerHistoryId, setSelectedDancerHistoryId] = React.useState(null);

    const [dancerHistory, setDancerHistory] = React.useState(null);

    const [openHistory, setOpenHistory] = useState(false);

    const [privateDancePayFeatureFlag, setPrivateDancePayFeatureFlag] = React.useState(false);
    const [dancePayFeatureFlag, setDancePayFeatureFlag] = React.useState(false);
    const [stageTipFeatureFlag, setStageTipFeatureFlag] = React.useState(false);
    const [payoutPinNumberFeatureFlag, setPayoutPinNumberFeatureFlag] = React.useState(false);
    const [payoutScanFeatureFlag, setPayoutScanFeatureFlag] = React.useState(false);

    const [isRefreshing, setIsRefreshing] = React.useState(false);
    const [refreshSuccess, setRefreshSuccess] = React.useState(false);

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.id !== "null") {
                setVenueId(venueSession.venueId);
                setVenueName(venueSession.venueName);
            } else {
                navigate('/login/mobile', {replace: true});
            }

            if (venueSession) {
                setPrivateDancePayFeatureFlag(venueSession.privateDancePayFeatureFlag);
                setDancePayFeatureFlag(venueSession.dancePayFeatureFlag);
                setStageTipFeatureFlag(venueSession.stageTipFeatureFlag);
                setPayoutPinNumberFeatureFlag(venueSession.payoutPinNumberFeatureFlag);
                setPayoutScanFeatureFlag(venueSession.payoutScanFeatureFlag);
            } else {
                setPrivateDancePayFeatureFlag(false);
                setDancePayFeatureFlag(false);
                setStageTipFeatureFlag(false);
                setPayoutPinNumberFeatureFlag(false);
                setPayoutScanFeatureFlag(false);
            }
        })
        return function cleanup() {

        };
    }, []);

    const getSuccess = async responseJson => {
        setIsRefreshing(false);

        if (
            responseJson
        ) {
            setPeople(responseJson.dancers);
            setPeopleFiltered(responseJson.dancers);
            setDancerOnStage(responseJson.dancerIdMainStage);
            setAvailableToPayOutVT(responseJson.availableToPayOutVT);
        } else {
            setErrorMessage("Error getting dancer list, please refresh and verify Internet Connection.");
        }
    };

    const getSuccessAndShowRefresh = async responseJson => {
        setIsRefreshing(false);
        if (
            responseJson
        ) {
            setPeople(responseJson.dancers);
            setPeopleFiltered(responseJson.dancers);
            setDancerOnStage(responseJson.dancerIdMainStage);
            setAvailableToPayOutVT(responseJson.availableToPayOutVT);
            showSuccessfullyRefreshed();
        } else {
            setErrorMessage("Error getting dancer list, please refresh and verify Internet Connection.");
        }
    };

    const showSuccessfullyRefreshed = () => {
        setRefreshSuccess(true);
        setTimeout(() => {
            setRefreshSuccess(false);
        }, 2000);
    };

    const getError = forceLogout => {
        setIsRefreshing(false);
        setErrorMessage("Error getting dancer list, please refresh and verify Internet Connection.");
    };

    const getDancerTipsSuccess = async responseJson => {
        if (
            responseJson && responseJson.id
        ) {
            setSelectedDancerId(responseJson.id);
            setDancer(responseJson);
            setTotalPayout(responseJson.totalAmount);
        } else {
            setErrorMessage("Error getting dancer tips, please refresh and verify Internet Connection.");
        }
    };

    const getDancerTipsError = forceLogout => {
        setErrorMessage("Error getting dancer tips, please refresh and verify Internet Connection.");
    };

    useEffect(() => {

        if (selectedDancerId !== null) {
            setDancer(null);
            findVenueDancerTipsAndDancesTotal(venueId, selectedDancerId, getDancerTipsSuccess, getDancerTipsError, getAccessTokenSilently);

        }
        return function cleanup() {

        };
    }, [selectedDancerId]);

    const getDancerTipsHistorySuccess = async responseJson => {
        if (
            responseJson && responseJson.id
        ) {
            setDancerHistory(responseJson);
            setTotalPayout(responseJson.totalAmount);
        } else {
            setErrorMessage("Error getting dancer tips history, please refresh and verify Internet Connection.");
        }
    };

    const getDancerTipsHistoryError = forceLogout => {
        setErrorMessage("Error getting dancer tips history, please refresh and verify Internet Connection.");
    };

    useEffect(() => {

        if (selectedDancerHistoryId !== null) {
            setDancerHistory(null);
            findVenueDancerTipsAndDancesHistory(venueId, selectedDancerHistoryId, getDancerTipsHistorySuccess, getDancerTipsHistoryError, getAccessTokenSilently);

        }
        return function cleanup() {

        };
    }, [selectedDancerHistoryId]);

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            findVenueDancersPayout(venueId, getSuccess, getError, getAccessTokenSilently);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    const processDancerTipsSuccess = async responseJson => {
        setIsProcessingDancerTips(false);

        if (responseJson && responseJson.error) {
            setErrorMessage(responseJson.message);
            setShowError(true);
            setShowErrorMessage(responseJson.message);
            await new Audio(soundError).play();
        } else if (
            responseJson && (responseJson.availableToPayOutVT >= 0)
        ) {
            setOpenPayoutSuccessful(true);
            setOpen(false);
            setOpenPayoutPinNumber(false)
            setSelectedDancerId(null);
            // setTotalPayout(0);
            setPayoutPinNumber(null);
            setAvailableToPayOutVT(responseJson.availableToPayOutVT);
            setErrorMessage(null);
            setShowError(false);
            setShowErrorMessage(null);
            await new Audio(sound).play();

            // Refresh the dancer list so the paid-out dancer is removed from the screen
            if (!isLoading && venueId !== null) {
                setIsRefreshing(true);
                findVenueDancersPayout(venueId, getSuccess, getError, getAccessTokenSilently);
            }
        } else {
            setErrorMessage("Error processing dancer tips, please refresh and verify Internet Connection.");
            setShowError(true);
            setShowErrorMessage(responseJson.message);
            setOpen(false);
            setOpenPayoutPinNumber(false);
            await new Audio(soundError).play();
        }
    };

    const processDancerTipsError = forceLogout => {
        setIsProcessingDancerTips(false);
        setErrorMessage("Error processing dancer tips, please refresh and verify Internet Connection.");
        setOpen(false);
        setOpenPayoutPinNumber(false);
    };

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            // Set up the interval
            const intervalId = setInterval(() => {
                setIsRefreshing(true);
                findVenueDancersPayout(venueId, getSuccessAndShowRefresh, getError, getAccessTokenSilently);
            }, 600000); // Update every 10 minutes

            // Cleanup function
            return () => {
                clearInterval(intervalId);
            };
        }
    }, [isLoading]);

    const submitPayout = (selectedSize, dancerString) => {
        const dancer = JSON.parse(dancerString);

        if (!dancer.id || dancer.id.trim() === "" || selectedSize !== dancer.id) {
            setErrorMessage("Error processing dancer tips, please refresh and verify Internet Connection.");
            setShowError(true);
            setShowErrorMessage("Failed to process dancer tips, please verify correct dancer selected and try again!");
            setTimeout(() => {
                setShowError(false);
            }, 10000);
            new Audio(soundError).play();
            return;
        }

        setErrorMessage(null);
        setIsProcessingDancerTips(true);
        processDancerTips(venueId, dancer.id, dancer.payoutPinNumber, processDancerTipsSuccess, processDancerTipsError, getAccessTokenSilently);

    };
    //TODO get qr reader sending getting the right info and sending the right info
    //add more values to qr reader
    // UPDATE PAYOUT HISTORY TO LAST 30 DAYS or 45 days and add in tips / dances toggle
    //ENSURE THAT PAYOUT HISTORY ONLY SHOWS FOR THIS VENUE!! and also tips to payout
    return (
        <>
            {
                showQRReader && dancer ?
                    <VTPayoutDancerQRReader setIsQRReader={null} submitVT={submitPayout}
                                            selectedSize={selectedDancerId}
                                            dancer={dancer}
                                            totalPayout={totalPayout}
                                            setShowQRReader={setShowQRReader}/> :
                    <>
                        <div>
                            <div className="mx-auto max-w-7xl px-4 pt-12 pb-4 sm:px-6 lg:px-8">
                                <div className="sm:align-center sm:flex sm:flex-col">
                                    <h1 className="text-5xl font-bold tracking-tight text-gray-900 dark:text-gray-100 text-center">Dancer<span
                                        className="text-pink-400">Payout</span></h1>
                                </div>
                                {availableToPayOutVT !== null &&
                                    <div className="mt-4 flex flex-col items-center">
                                        <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-gray-100 text-center">Available
                                            Payout
                                            Cash : <NumericFormat value={availableToPayOutVT} displayType={'text'}
                                                                  decimalScale={2} fixedDecimalScale={true}
                                                                  thousandSeparator={true} prefix={'$'}/></h3>
                                    </div>}
                            </div>

                            <div className="px-6">
                                <div className="relative mt-2 rounded-md shadow-sm">
                                    <div
                                        className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                        <UsersIcon className="h-5 w-5 text-gray-400 dark:text-gray-500" aria-hidden="true"/>
                                    </div>
                                    <input
                                        type="text"
                                        name="search"
                                        className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 dark:text-gray-100 dark:bg-gray-800 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                                        placeholder="Search"
                                        onChange={(event) => {
                                            if (event.target.value && event.target.value.length > 0) {
                                                let filteredPeople = (people || []).filter(function (dancer) {
                                                    return dancer.name.substring(0, event.target.value.length).toLowerCase() === event.target.value.toLowerCase();
                                                });
                                                setPeopleFiltered(filteredPeople);
                                            } else {
                                                setPeopleFiltered(people);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col items-center mt-3">
                                <p className="text-center">
                                    {refreshSuccess ?
                                        <button
                                            type="button"
                                            disabled={true}
                                            className="inline-flex items-center gap-x-2 rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                        >
                                            Successfully Refreshed
                                            <CheckCircleIcon aria-hidden="true" className="-mr-0.5 size-5"/>
                                        </button>
                                        : <button
                                            onClick={(event) => {
                                                if (!isLoading && venueId !== null) {
                                                    setIsRefreshing(true);
                                                    findVenueDancersPayout(venueId, getSuccessAndShowRefresh, getError, getAccessTokenSilently);
                                                }
                                            }}
                                            type="button"
                                            disabled={isRefreshing}
                                            className="inline-flex items-center gap-x-2 rounded-md bg-pink-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-pink-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                        >
                                            Refresh List
                                            {isRefreshing ?
                                                <ArrowPathIcon aria-hidden="true"
                                                               className="-mr-0.5 size-5 animate-spin"/> :
                                                <ArrowPathIcon aria-hidden="true" className="-mr-0.5 size-5"/>}
                                        </button>}
                                </p>
                            </div>


                            <div className="mt-6 flow-root px-6 pb-10">
                                {!people && <DancerListSkeleton/>}
                                <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700">
                                    {people && people.length === 0 &&
                                        <h3 className="text-sm text-gray-500 dark:text-gray-400">No Dancers are checked in.</h3>}
                                    {peopleFiltered && peopleFiltered.map((person) => (
                                        <li key={person.id} className="py-4">
                                            <div className="flex items-start justify-between gap-3">
                                                <div className="min-w-0 flex-1">
                                                    <p className="truncate text-base font-semibold text-gray-900 dark:text-gray-100">{person.name}</p>
                                                    <p className="truncate text-sm text-gray-500 dark:text-gray-400">{person.dancerCode}</p>
                                                    {(person.payoutPinNumber !== null && person.payoutPinNumber !== undefined) &&
                                                        <p className="truncate text-sm text-gray-500 dark:text-gray-400">Pin: {person.payoutPinNumber}</p>}
                                                </div>
                                                {dancerOnStage !== person.id ? <div className="flex flex-shrink-0 flex-col items-stretch gap-2">
                                                    {!payoutPinNumberFeatureFlag &&
                                                        <button
                                                            className="inline-flex items-center justify-center rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-pink-500 active:bg-pink-700"
                                                            onClick={() => {
                                                                setSelectedDancerId(person.id);
                                                                setOpen(true);
                                                            }}
                                                        >
                                                            Pay Out
                                                        </button>}
                                                    {payoutScanFeatureFlag &&
                                                        <button
                                                            className="inline-flex items-center justify-center rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-pink-500 active:bg-pink-700"
                                                            onClick={() => {
                                                                setSelectedDancerId(person.id);
                                                                setShowQRReader(true);
                                                            }}
                                                        >
                                                            Payout (Scan)
                                                        </button>}
                                                    {payoutPinNumberFeatureFlag &&
                                                        <button
                                                            className="inline-flex items-center justify-center rounded-lg bg-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-pink-500 active:bg-pink-700"
                                                            onClick={() => {
                                                                setSelectedDancerId(person.id);
                                                                setOpenPayoutPinNumber(true);
                                                            }}
                                                        >
                                                            Payout (Input)
                                                        </button>}
                                                </div> : <span className="inline-flex flex-shrink-0 items-center rounded-full bg-pink-100 px-3 py-1 text-xs font-bold uppercase tracking-wide text-pink-700">
                                                    On Stage
                                                </span>}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/*Tip Payout */}
                        <Transition.Root show={open} as={Fragment}>
                            <Dialog as="div" className="relative z-10" onClose={setOpen}>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-in-out duration-500"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-500"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                                </Transition.Child>

                                <div className="fixed inset-0 overflow-hidden">
                                    <div className="absolute inset-0 overflow-hidden">
                                        <div
                                            className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                            <Transition.Child
                                                as={Fragment}
                                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                                enterFrom="translate-x-full"
                                                enterTo="translate-x-0"
                                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                                leaveFrom="translate-x-0"
                                                leaveTo="translate-x-full"
                                            >
                                                <Dialog.Panel className="pointer-events-auto relative w-96">
                                                    <Transition.Child
                                                        as={Fragment}
                                                        enter="ease-in-out duration-500"
                                                        enterFrom="opacity-0"
                                                        enterTo="opacity-100"
                                                        leave="ease-in-out duration-500"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <div
                                                            className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                                                            <button
                                                                type="button"
                                                                className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setOpen(false);
                                                                    setSelectedDancerId(null);
                                                                    setTotalPayout(0);
                                                                    setPayoutPinNumber(null);
                                                                    setErrorMessage(null);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </Transition.Child>
                                                    <div className="h-full overflow-y-auto bg-white dark:bg-gray-800 p-8">
                                                        {dancer && <div className="space-y-6 pb-16">
                                                            <div>
                                                                {/*<div className="aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg">*/}
                                                                {/*    <img*/}
                                                                {/*        src="https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80"*/}
                                                                {/*        alt=""*/}
                                                                {/*        className="object-cover"*/}
                                                                {/*    />*/}
                                                                {/*</div>*/}
                                                                <div className="mt-4 flex items-start justify-between">
                                                                    <div>
                                                                        <h2 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
                                                                <span
                                                                    className="sr-only">Details for </span> {dancer && dancer.name}
                                                                        </h2>
                                                                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{dancer && dancer.dancerCode}</p>
                                                                    </div>
                                                                    {/*<button*/}
                                                                    {/*    type="button"*/}
                                                                    {/*    className="ml-4 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500"*/}
                                                                    {/*>*/}
                                                                    {/*    <HeartIcon className="h-6 w-6" aria-hidden="true" />*/}
                                                                    {/*    <span className="sr-only">Favorite</span>*/}
                                                                    {/*</button>*/}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <h3 className="font-medium text-gray-900 dark:text-gray-100">Payout</h3>
                                                                <dl className="mt-2 divide-y divide-gray-200 dark:divide-gray-700 border-t border-gray-200 dark:border-gray-700">
                                                                    {dancer && dancer.id &&
                                                                        <>
                                                                            {stageTipFeatureFlag && <div
                                                                                className="flex justify-between py-3 text-sm font-medium">
                                                                                <dt className="text-gray-500 dark:text-gray-400">Tips</dt>
                                                                                <dd className="text-gray-900 dark:text-gray-100">{dancer.tipAmount} VT</dd>
                                                                            </div>}
                                                                            {(privateDancePayFeatureFlag || dancePayFeatureFlag) &&
                                                                                <div
                                                                                    className="flex justify-between py-3 text-sm font-medium">
                                                                                    <dt className="text-gray-500 dark:text-gray-400">Dances</dt>
                                                                                    <dd className="text-gray-900 dark:text-gray-100">{dancer.danceAmount} VT</dd>
                                                                                </div>}
                                                                        </>
                                                                    }

                                                                    <div
                                                                        className="flex justify-between py-3 text-sm font-medium">
                                                                        <dt className="text-gray-500 dark:text-gray-400">Total</dt>
                                                                        <dd className="text-gray-900 dark:text-gray-100">${totalPayout}</dd>
                                                                    </div>
                                                                </dl>
                                                            </div>

                                                            <div className="flex">
                                                                <button
                                                                    disabled={isProcessingDancerTips}
                                                                    type="button"
                                                                    className="flex-1 rounded-md bg-pink-600 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                                    onClick={() => {
                                                                        if (totalPayout >= 0) {
                                                                            setIsProcessingDancerTips(true);
                                                                            processDancerTips(venueId, selectedDancerId, 0, processDancerTipsSuccess, processDancerTipsError, getAccessTokenSilently);
                                                                        } else {
                                                                            setOpen(false);
                                                                            setSelectedDancerId(null);
                                                                            setTotalPayout(0);
                                                                            setPayoutPinNumber(null);
                                                                            setErrorMessage(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    Process Payout {isProcessingDancerTips &&
                                                                    <CircularProgress color="inherit" size={20}/>}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="ml-3 flex-1 rounded-md bg-white dark:bg-gray-800 py-2 px-3 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                                    onClick={() => {
                                                                        setOpen(false);
                                                                        setSelectedDancerId(null);
                                                                        setTotalPayout(0);
                                                                        setPayoutPinNumber(null);
                                                                        setErrorMessage(null);
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                            {errorMessage && <FormError errorMessage={errorMessage}/>}
                                                        </div>}
                                                    </div>
                                                </Dialog.Panel>
                                            </Transition.Child>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>

                        {/*Tip Payout Pin Number*/}
                        <Transition.Root show={openPayoutPinNumber} as={Fragment}>
                            <Dialog as="div" className="relative z-10" onClose={setOpenPayoutPinNumber}>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-in-out duration-500"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-500"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                                </Transition.Child>

                                <div className="fixed inset-0 overflow-hidden">
                                    <div className="absolute inset-0 overflow-hidden">
                                        <div
                                            className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                            <Transition.Child
                                                as={Fragment}
                                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                                enterFrom="translate-x-full"
                                                enterTo="translate-x-0"
                                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                                leaveFrom="translate-x-0"
                                                leaveTo="translate-x-full"
                                            >
                                                <Dialog.Panel className="pointer-events-auto relative w-96">
                                                    <Transition.Child
                                                        as={Fragment}
                                                        enter="ease-in-out duration-500"
                                                        enterFrom="opacity-0"
                                                        enterTo="opacity-100"
                                                        leave="ease-in-out duration-500"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <div
                                                            className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                                                            <button
                                                                type="button"
                                                                className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setOpenPayoutPinNumber(false);
                                                                    setSelectedDancerId(null);
                                                                    setTotalPayout(0);
                                                                    setPayoutPinNumber(null);
                                                                    setErrorMessage(null);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </Transition.Child>
                                                    <div className="h-full overflow-y-auto bg-white dark:bg-gray-800 p-8">
                                                        {dancer && <div className="space-y-6 pb-16">
                                                            <div>
                                                                {/*<div className="aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg">*/}
                                                                {/*    <img*/}
                                                                {/*        src="https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80"*/}
                                                                {/*        alt=""*/}
                                                                {/*        className="object-cover"*/}
                                                                {/*    />*/}
                                                                {/*</div>*/}
                                                                <div className="mt-4 flex items-start justify-between">
                                                                    <div>
                                                                        <h2 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
                                                                <span
                                                                    className="sr-only">Details for </span> {dancer && dancer.name}
                                                                        </h2>
                                                                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{dancer && dancer.dancerCode}</p>
                                                                    </div>
                                                                    {/*<button*/}
                                                                    {/*    type="button"*/}
                                                                    {/*    className="ml-4 flex h-8 w-8 items-center justify-center rounded-full bg-white text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500"*/}
                                                                    {/*>*/}
                                                                    {/*    <HeartIcon className="h-6 w-6" aria-hidden="true" />*/}
                                                                    {/*    <span className="sr-only">Favorite</span>*/}
                                                                    {/*</button>*/}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <h3 className="font-medium text-gray-900 dark:text-gray-100">Payout</h3>
                                                                <dl className="mt-2 divide-y divide-gray-200 dark:divide-gray-700 border-t border-gray-200 dark:border-gray-700">
                                                                    {dancer && dancer.id &&
                                                                        <>
                                                                            {stageTipFeatureFlag && <div
                                                                                className="flex justify-between py-3 text-sm font-medium">
                                                                                <dt className="text-gray-500 dark:text-gray-400">Tips</dt>
                                                                                <dd className="text-gray-900 dark:text-gray-100">{dancer.tipAmount} VT</dd>
                                                                            </div>}
                                                                            {(privateDancePayFeatureFlag || dancePayFeatureFlag) &&
                                                                                <div
                                                                                    className="flex justify-between py-3 text-sm font-medium">
                                                                                    <dt className="text-gray-500 dark:text-gray-400">Dances</dt>
                                                                                    <dd className="text-gray-900 dark:text-gray-100">{dancer.danceAmount} VT</dd>
                                                                                </div>}
                                                                        </>
                                                                    }

                                                                    <div
                                                                        className="flex justify-between py-3 text-sm font-medium">
                                                                        <dt className="text-gray-500 dark:text-gray-400">Total</dt>
                                                                        <dd className="text-gray-900 dark:text-gray-100">${totalPayout}</dd>
                                                                    </div>
                                                                </dl>
                                                            </div>

                                                            <div>
                                                                <label htmlFor="payoutPinNumber"
                                                                       className="block text-sm/6 font-medium text-gray-900">
                                                                    Payout Pin Number
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        onChange={(event) => {
                                                                            setPayoutPinNumber(event.target.value);
                                                                        }}
                                                                        name="payoutPinNumber"
                                                                        type="number"
                                                                        placeholder="12345678"
                                                                        aria-describedby="payoutPinNumber"
                                                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-pink-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-pink-600 sm:text-sm/6"
                                                                    />
                                                                </div>
                                                                <p className="mt-2 text-sm text-gray-500">
                                                                    Enter the dancer Payout Pin Number and click confirm
                                                                    payout
                                                                    button.
                                                                </p>
                                                            </div>

                                                            <div className="flex">
                                                                <button
                                                                    disabled={isProcessingDancerTips}
                                                                    type="button"
                                                                    className="flex-1 rounded-md bg-pink-600 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                                                    onClick={() => {
                                                                        if (totalPayout >= 0) {
                                                                            setIsProcessingDancerTips(true);
                                                                            processDancerTips(venueId, selectedDancerId, payoutPinNumber, processDancerTipsSuccess, processDancerTipsError, getAccessTokenSilently);
                                                                        } else {
                                                                            // setOpenPayoutPinNumber(false);
                                                                            // setSelectedDancerId(null);
                                                                            // setTotalPayout(0);
                                                                            // setPayoutPinNumber(null);
                                                                            setErrorMessage("Process Payout FAILED, Incorrect Payout Pin Number");
                                                                        }
                                                                    }}
                                                                >
                                                                    Confirm Payout {isProcessingDancerTips &&
                                                                    <CircularProgress color="inherit" size={20}/>}
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="ml-3 flex-1 rounded-md bg-white dark:bg-gray-800 py-2 px-3 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                                    onClick={() => {
                                                                        setOpenPayoutPinNumber(false);
                                                                        setSelectedDancerId(null);
                                                                        setTotalPayout(0);
                                                                        setPayoutPinNumber(null);
                                                                        setErrorMessage(null);
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                            {errorMessage && <FormError errorMessage={errorMessage}/>}
                                                        </div>}
                                                    </div>
                                                </Dialog.Panel>
                                            </Transition.Child>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>

                        {/*Tip Payout History*/}
                        <Transition.Root show={openHistory} as={Fragment}>
                            <Dialog as="div" className="relative z-10" onClose={setOpenHistory}>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-in-out duration-500"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-500"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                                </Transition.Child>

                                <div className="fixed inset-0 overflow-hidden">
                                    <div className="absolute inset-0 overflow-hidden">
                                        <div
                                            className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                                            <Transition.Child
                                                as={Fragment}
                                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                                enterFrom="translate-x-full"
                                                enterTo="translate-x-0"
                                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                                leaveFrom="translate-x-0"
                                                leaveTo="translate-x-full"
                                            >
                                                <Dialog.Panel className="pointer-events-auto relative w-96">
                                                    <Transition.Child
                                                        as={Fragment}
                                                        enter="ease-in-out duration-500"
                                                        enterFrom="opacity-0"
                                                        enterTo="opacity-100"
                                                        leave="ease-in-out duration-500"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <div
                                                            className="absolute top-0 left-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
                                                            <button
                                                                type="button"
                                                                className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                                onClick={() => {
                                                                    setOpenHistory(false);
                                                                    setSelectedDancerHistoryId(null);
                                                                    setTotalPayout(0);
                                                                    setPayoutPinNumber(null);
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <XMarkIcon className="h-6 w-6" aria-hidden="true"/>
                                                            </button>
                                                        </div>
                                                    </Transition.Child>
                                                    {dancerHistory &&
                                                        <div className="h-full overflow-y-auto bg-white dark:bg-gray-800 p-8">
                                                            <div className="space-y-6 pb-16">
                                                                <div>
                                                                    <div
                                                                        className="mt-4 flex items-start justify-between">
                                                                        <div>
                                                                            <h2 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100">
                                                            <span
                                                                className="sr-only">Details for </span> {dancerHistory && dancerHistory.name}
                                                                            </h2>
                                                                            <p className="text-sm font-medium text-gray-500">{dancerHistory && dancerHistory.dancerCode}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <h3 className="font-medium text-gray-900">Payout
                                                                        History</h3>
                                                                    <dl className="mt-2 divide-y divide-gray-200 border-t border-b border-gray-200">
                                                                        {dancerHistory && dancerHistory.id && dancerHistory.tips.map((tip) => (
                                                                            <div
                                                                                key={tip.id}
                                                                                className="flex justify-between py-3 text-sm font-medium">
                                                                                <dt className="text-gray-500">{dateFormat(tip.createDate, "mmmm dS, yyyy")} (Tips)</dt>
                                                                                <dd className="text-gray-900">{tip.tipAmount} VT</dd>
                                                                            </div>

                                                                        ))}
                                                                        {dancerHistory && dancerHistory.id && dancerHistory.dances.map((dance) => (
                                                                            <div
                                                                                key={dance.id}
                                                                                className="flex justify-between py-3 text-sm font-medium">
                                                                                <dt className="text-gray-500">{dateFormat(dance.createDate, "mmmm dS, yyyy")} (Dances)</dt>
                                                                                <dd className="text-gray-900">{dance.danceAmount} VT</dd>
                                                                            </div>

                                                                        ))}
                                                                        <div
                                                                            className="flex justify-between py-3 text-sm font-medium">
                                                                            <dt className="text-gray-500">Total</dt>
                                                                            <dd className="text-gray-900">${totalPayout}</dd>
                                                                        </div>
                                                                    </dl>
                                                                </div>

                                                                <div className="flex">

                                                                    <button
                                                                        type="button"
                                                                        className="ml-3 flex-1 rounded-md bg-white dark:bg-gray-800 py-2 px-3 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800"
                                                                        onClick={() => {
                                                                            setOpenHistory(false);
                                                                            setSelectedDancerHistoryId(null);
                                                                            setTotalPayout(0);
                                                                            setPayoutPinNumber(null);
                                                                        }}
                                                                    >
                                                                        Close
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                </Dialog.Panel>
                                            </Transition.Child>
                                        </div>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>


                        <Dialog open={openPayoutSuccessful} onClose={setOpenPayoutSuccessful} className="relative z-10">
                            <DialogBackdrop
                                transition
                                className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
                            />

                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                <div
                                    className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <DialogPanel
                                        transition
                                        className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-closed:sm:translate-y-0 data-closed:sm:scale-95"
                                    >
                                        <div>
                                            <div
                                                className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                                                <CheckIcon aria-hidden="true" className="size-6 text-green-600"/>
                                            </div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                                    Pay {dancer && dancer.name} ${totalPayout} dollars.
                                                </DialogTitle>
                                                <div className="mt-2">
                                                    <p className="text-sm text-gray-500">
                                                        Payout Successful
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mt-5 sm:mt-6">
                                            <button
                                                type="button"
                                                onClick={() => setOpenPayoutSuccessful(false)}
                                                className="inline-flex w-full justify-center rounded-md bg-pink-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-pink-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                                            >
                                                Done
                                            </button>
                                        </div>
                                    </DialogPanel>
                                </div>
                            </div>
                        </Dialog>
                    </>
            }


            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                    <Transition
                        show={showError}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div
                            className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                            <div className="p-4">
                                <div className="flex items-start">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true"/>
                                    </div>
                                    <div className="ml-3 w-0 flex-1 pt-0.5">
                                        <p className="text-sm font-medium text-gray-900">{showErrorMessage}</p>
                                        {/*<p className="mt-1 text-sm text-gray-500">{selectedSize && selectedSize.virtualTips} VirtualTipz</p>*/}
                                    </div>
                                    <div className="ml-4 flex flex-shrink-0">
                                        <button
                                            type="button"
                                            className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
                                            onClick={() => {
                                                setShowError(false);
                                                setErrorMessage(false);
                                            }}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-5 w-5" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </>
    )
}